import {Button} from "@material-ui/core";
import React from "react";

interface SaveCalculationExceededProxiexButtonProps {
    onClick: (event: any) => void;
    exceededProxies: boolean;
}

export default function SaveCalculationExceededProxiesButton(props: SaveCalculationExceededProxiexButtonProps) {
    return (
        !props.exceededProxies ?
                <Button variant="contained"
                        className="next-button"
                        onClick={props.onClick}
                >
                    Wyślij do akceptacji TUZ
                </Button>: null
    );
}